"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _classnames = _interopRequireDefault(require("classnames"));
var _Layout = require("../Layout");
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MenuItem = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    as,
    className,
    children,
    disabled,
    style,
    ...props
  } = _ref;
  const {
    theme: {
      menu: {
        item: itemTheme
      }
    }
  } = (0, _Theme.useThemeConfig)();
  return /*#__PURE__*/_react.default.createElement(_react2.Menu.Item, {
    as: _react.Fragment,
    disabled: disabled
  }, _ref2 => {
    let {
      active,
      close
    } = _ref2;
    return typeof children === "function" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", children({
      active,
      close
    }), " ") : /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
      as: as || "a",
      text: itemTheme.base.text,
      p: itemTheme.base.p,
      w: itemTheme.base.w,
      font: itemTheme.base.font,
      hover: itemTheme.base.hover,
      className: (0, _classnames.default)(className, itemTheme.base.position, {
        [itemTheme.active]: active,
        [itemTheme.disabled]: disabled
      }),
      ref: ref,
      style: {
        ...style,
        outlineOffset: -3
      },
      disabled: disabled
    }, props), children);
  });
});
exports.MenuItem = MenuItem;
MenuItem.displayName = "Menu.Item";